import type {
  MetricName,
  MetricTags,
  MetricTagsByName,
} from 'src/internal/metrics/types';
import type {ObservabilityConfig} from 'src/types';

export default function buildParams<T extends MetricName>(
  config: ObservabilityConfig,
  parameters?: MetricTagsByName,
): MetricTags<T> | undefined {
  const configParameters: MetricTagsByName = config.metrics?.parameters || {};
  const result: MetricTagsByName = {...configParameters, ...parameters};

  if (Object.keys(result).length === 0) {
    return undefined;
  }

  return result as MetricTags<T>;
}
